export const PHOTOS = {
  hero: "https://customer-assets-cm19k8pv.emergentagent.net/job_exclusive-models-1/artifacts/1fd83fd2a8f465d1_Retrato%20parisino%20con%20capa%20de%20piel.png",
  founder:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_exclusive-models-1/artifacts/2d510472e1cfad25_marjolaine_web_optimizada%20%281%29.jpg",
  founder_urban:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_exclusive-models-1/artifacts/74364edadfb17151_IMG_1490%282%29.jpeg",
  studio:
    "https://images.unsplash.com/photo-1586732711591-12c04655338f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMGRpcmVjdG9yJTIwZmFzaGlvbiUyMG9mZmljZSUyMHN0dWRpb3xlbnwwfHx8fDE3OTE1MTQ4NDl8MA&ixlib=rb-4.1.0&q=85",
  editing:
    "https://images.unsplash.com/photo-1744686909358-915e14866592?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxjcmVhdGl2ZSUyMGRpcmVjdG9yJTIwZmFzaGlvbiUyMG9mZmljZSUyMHN0dWRpb3xlbnwwfHx8fDE3OTE1MTQ4NDl8MA&ixlib=rb-4.1.0&q=85",
  fashion:
    "https://images.unsplash.com/photo-1612242879330-cd06b2696e56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxjcmVhdGl2ZSUyMGRpcmVjdG9yJTIwZmFzaGlvbiUyMG9mZmljZSUyMHN0dWRpb3xlbnwwfHx8fDE3OTE1MTQ4NDl8MA&ixlib=rb-4.1.0&q=85",
};

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
